import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import getPasswordError from "assets/scripts/utils/getPasswordError";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import Form from "assets/scripts/components/common/form/Form/Form";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    submit: {
        id: "forms.passwordChange.submit",
        defaultMessage: "Save Password"
    },
    securityQuestionLabel: {
        id: "forms.passwordChange.securityQuestion.label",
        defaultMessage: "Security question"
    },
    securityQuestionNullOption: {
        id: "forms.passwordChange.securityQuestion.nullOption",
        defaultMessage: "Select a Security Question"
    },
    securityAnswerLabel: {
        id: "forms.passwordChange.securityAnswer.label",
        defaultMessage: "Security answer"
    },
    passwordOldLabel: {
        id: "forms.passwordChange.passwordOld.label",
        defaultMessage: "Old password"
    },
    passwordNewLabel: {
        id: "forms.passwordChange.passwordNew.label",
        defaultMessage: "New password"
    },
    passwordConfirmLabel: {
        id: "forms.passwordChange.passwordConfirm.label",
        defaultMessage: "Confirm your password"
    },
    passwordConfirmHelp: {
        id: "forms.passwordChange.passwordConfirm.help",
        defaultMessage: "Must match the new password field"
    }
});
function getErrors(value) {
    const passwordValid = value.passwordNew.length > 0;
    const passwordConfirmValid = value.passwordConfirm.length > 0;
    const passwordsMatch = value.passwordNew === value.passwordConfirm;
    return {
        securityQuestion: isEmpty(value.securityQuestion) ? REQUIRED : null,
        securityAnswer: isEmpty(value.securityAnswer) ? REQUIRED : null,
        passwordOld: isEmpty(value.passwordOld) ? REQUIRED : null,
        passwordNew: getPasswordError(passwordValid, passwordConfirmValid, passwordsMatch),
        passwordConfirm: getPasswordError(passwordConfirmValid, passwordValid, passwordsMatch)
    };
}
export default class PasswordChangeForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleSecurityQuestionChange = (securityQuestion) => this.setState({ securityQuestion });
        this._handleSecurityAnswerChange = (securityAnswer) => this.setState({ securityAnswer });
        this._handlePasswordOldChange = (passwordOld) => this.setState({ passwordOld });
        this._handlePasswordNewChange = (passwordNew) => this.setState({ passwordNew });
        this._handlePasswordConfirmChange = (passwordConfirm) => this.setState({ passwordConfirm });
        this.state = {
            securityQuestion: "",
            securityAnswer: "",
            passwordOld: "",
            passwordNew: "",
            passwordConfirm: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        const questions = props.securityQuestions == null ? [] : props.securityQuestions.questions;
        const securityQuestionOptions = [
            {
                value: "",
                label: messages.securityQuestionNullOption
            },
            ...questions.map(({ id, question, questionES }) => ({
                value: id.toString(),
                label: props.locale === "es" ? questionES : question
            }))
        ];
        return (<Form isBusy={props.isLoading || props.securityQuestions == null} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.passwordChange.legend" defaultMessage="Security Information"/>
						</span>
					</legend>

					<SelectFormGroup name="securityQuestion" label={messages.securityQuestionLabel} value={value.securityQuestion} onChange={this._handleSecurityQuestionChange} error={errors.securityQuestion} required options={securityQuestionOptions}/>

					<TextFormGroup name="securityAnswer" label={messages.securityAnswerLabel} value={value.securityAnswer} onChange={this._handleSecurityAnswerChange} error={errors.securityAnswer} backendError={backendErrors.answer} required inputProps={{
            autoComplete: "security-answer"
        }}/>

					<TextFormGroup type="password" name="passwordOld" label={messages.passwordOldLabel} value={value.passwordOld} onChange={this._handlePasswordOldChange} error={errors.passwordOld} backendError={backendErrors.oldPassword} inputProps={{
            autoComplete: "current-password"
        }} required/>

					<TextFormGroup type="password" name="passwordNew" label={messages.passwordNewLabel} value={value.passwordNew} onChange={this._handlePasswordNewChange} error={errors.passwordNew} backendError={backendErrors.newPassword} inputProps={{
            autoComplete: "new-password"
        }} required/>

					<TextFormGroup type="password" name="passwordConfirm" label={messages.passwordConfirmLabel} help={messages.passwordConfirmHelp} value={value.passwordConfirm} onChange={this._handlePasswordConfirmChange} error={errors.passwordConfirm} inputProps={{
            autoComplete: "new-password"
        }} required/>
				</fieldset>

				{process.env.CLIENT !== "CapOne" && (<div className="text">
					<FormattedMessage id="createProfile.consent" defaultMessage="By clicking Save Password, you consent to receive a one-time password reset email to {email}." values={{
            email: props.email
        }} tagName="p"/>
				</div>)}
			</Form>);
    }
    _handleSubmit() {
        this.props.updatePassword(this.state);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PasswordChangeForm.tsx